import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { CreatedRes, ErrorRes } from '@/hooks/common';
import { axiosInstance } from '@/utils/axios';
import useAxiosErrorHandler from '@/hooks/useAxiosErrorHandler';

export type GroupCreateReq = {
  company: number;
  name: string;
  contract: string;
};

export type GroupCreateRes = CreatedRes;

const useGroupCreateMutation = () => {
  const axiosErrorHandler = useAxiosErrorHandler();
  return useMutation<GroupCreateRes, AxiosError<ErrorRes>, GroupCreateReq>(
    async (req: GroupCreateReq): Promise<GroupCreateRes> => {
      return (
        await axiosInstance()
          .post<GroupCreateRes>('/group/create', req)
          .catch((error: AxiosError) => {
            axiosErrorHandler(error);
            throw error;
          })
      ).data;
    }
  );
};

export default useGroupCreateMutation;
